import { type SVGProps } from 'react';

export const UserProfileIcon = (props: SVGProps<SVGSVGElement>): React.ReactElement => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.64 9.13997C14.64 7.68195 13.4581 6.5 12 6.5C10.542 6.5 9.36007 7.68195 9.36007 9.13997C9.36007 10.598 10.542 11.7799 12 11.7799C13.4581 11.7799 14.64 10.598 14.64 9.13997ZM12 7.5C12.9058 7.5 13.64 8.23424 13.64 9.13997C13.64 10.0457 12.9058 10.7799 12 10.7799C11.0943 10.7799 10.3601 10.0457 10.3601 9.13997C10.3601 8.23424 11.0943 7.5 12 7.5Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 12.0012C21 7.03064 16.9692 3 11.9985 3C7.02832 3 3 7.03063 3 12.0012C3 16.9718 7.02833 21 11.9985 21C16.9692 21 21 16.9718 21 12.0012ZM4 12.0012C4 7.58932 7.5879 4 11.9985 4C16.4106 4 20 7.58932 20 12.0012C20 14.5428 18.8081 16.8114 16.9536 18.2776V17.813C16.9536 16.5099 16.5868 15.2662 15.8633 14.3363C15.1309 13.3951 14.046 12.7959 12.6852 12.7959H11.3147C9.9539 12.7959 8.86897 13.3951 8.13661 14.3363C7.41312 15.2662 7.0463 16.5099 7.0463 17.813V18.2784C5.19192 16.8123 4 14.5433 4 12.0012ZM8.0463 18.9537V17.813C8.0463 16.6865 8.36466 15.6717 8.92586 14.9504C9.4782 14.2405 10.2775 13.7959 11.3147 13.7959H12.6852C13.7224 13.7959 14.5217 14.2405 15.0741 14.9504C15.6353 15.6717 15.9536 16.6865 15.9536 17.813V18.9528C14.7864 19.619 13.4361 20 11.9985 20C10.562 20 9.21275 19.6194 8.0463 18.9537Z"
        fill="white"
      />
    </svg>
  );
};
